import { render, staticRenderFns } from "./zb_model.vue?vue&type=template&id=9da41d36&scoped=true"
import script from "./zb_model.vue?vue&type=script&lang=ts"
export * from "./zb_model.vue?vue&type=script&lang=ts"
import style0 from "./zb_model.vue?vue&type=style&index=0&id=9da41d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da41d36",
  null
  
)

export default component.exports